import type { FC, ReactElement } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import type { OverlayTriggerProps } from "react-bootstrap/OverlayTrigger";

interface SimpleTooltipProps
	extends Omit<OverlayTriggerProps, "children" | "overlay"> {
	tooltip?: string;
	children: ReactElement;
}

export const SimpleTooltip: FC<SimpleTooltipProps> = (props) => {
	const { tooltip, children, placement = "auto", ...rest } = props;

	if (!tooltip) {
		return <span style={{ lineHeight: 1 }}>{children}</span>;
	}

	return (
		<OverlayTrigger {...rest} placement={placement} overlay={render(tooltip)}>
			<span style={{ lineHeight: 1 }}>{children}</span>
		</OverlayTrigger>
	);
};

const render = (tooltip: string) => (x: Record<string, unknown>) => {
	return <Tooltip {...x}>{tooltip}</Tooltip>;
};
